/* tslint:disable */
/* eslint-disable */
/**
 * OnData.SecureFile
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddFileTagInput
 */
export interface AddFileTagInput {
    /**
     * 
     * @type {string}
     * @memberof AddFileTagInput
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface BulkUpdateFileInput
 */
export interface BulkUpdateFileInput {
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateFileInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkUpdateFileInput
     */
    'fileIds'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateFileInput
     */
    'primaryClassification'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateFileInput
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkUpdateFileInput
     */
    'tags'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface CheckPermissionResponseDto
 */
export interface CheckPermissionResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof CheckPermissionResponseDto
     */
    'isSuccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CheckPermissionResponseDto
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CloudProvider {
    Azure = 1,
    AzureUSGovernment = 2,
    Aws = 3,
    Gcp = 4
}

/**
 * 
 * @export
 * @interface CustomKeyVaultDto
 */
export interface CustomKeyVaultDto {
    /**
     * 
     * @type {number}
     * @memberof CustomKeyVaultDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CustomKeyVaultDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {CloudProvider}
     * @memberof CustomKeyVaultDto
     */
    'cloudProvider'?: CloudProvider;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultDto
     */
    'clientSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultDto
     */
    'uri'?: string | null;
    /**
     * 
     * @type {CustomKeyVaultStatus}
     * @memberof CustomKeyVaultDto
     */
    'status'?: CustomKeyVaultStatus;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultDto
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface CustomKeyVaultInput
 */
export interface CustomKeyVaultInput {
    /**
     * 
     * @type {CloudProvider}
     * @memberof CustomKeyVaultInput
     */
    'cloudProvider'?: CloudProvider;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultInput
     */
    'tenantId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultInput
     */
    'clientId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultInput
     */
    'clientSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultInput
     */
    'uri': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CustomKeyVaultStatus {
    Init = 0,
    InProgress = 1,
    Success = 2,
    Failed = 3
}

/**
 * 
 * @export
 * @interface EncryptFileInput
 */
export interface EncryptFileInput {
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'absolutePath': string;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'machine': string;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'unencryptedHash': string;
    /**
     * 
     * @type {number}
     * @memberof EncryptFileInput
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'keyContent': string;
}
/**
 * 
 * @export
 * @interface EncryptFileResponseDto
 */
export interface EncryptFileResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EncryptFileResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptFileResponseDto
     */
    'fileKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileResponseDto
     */
    'combId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EncryptFileResponseDto
     */
    'fileAuditId'?: number;
}
/**
 * 
 * @export
 * @interface EncryptionKeyResponseDto
 */
export interface EncryptionKeyResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EncryptionKeyResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionKeyResponseDto
     */
    'encryptionKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionKeyResponseDto
     */
    'publicKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionKeyResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncryptionKeyResponseDto
     */
    'modifiedTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionKeyResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface FileAuditResponseDto
 */
export interface FileAuditResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'fileAuditId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'instanceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'action'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'sourceFileId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'sourceInstanceId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'sourceInstanceFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'sourceInstancePath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'sourceInstanceMachine'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'sourceInstanceUserId'?: number;
}
/**
 * 
 * @export
 * @interface FileAuditResponseDtoPaginationResult
 */
export interface FileAuditResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<FileAuditResponseDto>}
     * @memberof FileAuditResponseDtoPaginationResult
     */
    'items'?: Array<FileAuditResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface FileInstanceResponseDto
 */
export interface FileInstanceResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'instanceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'path'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'lastModified'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FileInstanceResponseDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'unencryptedHash'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'encryptionKeyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'parentFileId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'parentFileName'?: string | null;
}
/**
 * 
 * @export
 * @interface FileInstanceResponseDtoPaginationResult
 */
export interface FileInstanceResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<FileInstanceResponseDto>}
     * @memberof FileInstanceResponseDtoPaginationResult
     */
    'items'?: Array<FileInstanceResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface FileKeyResponseDto
 */
export interface FileKeyResponseDto {
    /**
     * 
     * @type {string}
     * @memberof FileKeyResponseDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileKeyResponseDto
     */
    'fileAuditId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileKeyResponseDto
     */
    'fileViewId'?: number;
}
/**
 * 
 * @export
 * @interface FileOperationInput
 */
export interface FileOperationInput {
    /**
     * 
     * @type {number}
     * @memberof FileOperationInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileOperationInput
     */
    'action': string;
}
/**
 * 
 * @export
 * @interface FileResponseDto
 */
export interface FileResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileResponseDto
     */
    'unencryptedHash'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'encryptionKeyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'parentFileId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileResponseDto
     */
    'parentFileName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FileResponseDto
     */
    'parentFileDeleted'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'primaryClassification'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FileResponseDto
     */
    'tags'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof FileResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface FileResponseDtoPaginationResult
 */
export interface FileResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<FileResponseDto>}
     * @memberof FileResponseDtoPaginationResult
     */
    'items'?: Array<FileResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface FileTagResponseDto
 */
export interface FileTagResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileTagResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileTagResponseDto
     */
    'tagId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileTagResponseDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface FileViewResponseDto
 */
export interface FileViewResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'fileViewId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'instanceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'timeStamp'?: string;
}
/**
 * 
 * @export
 * @interface FileViewResponseDtoPaginationResult
 */
export interface FileViewResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<FileViewResponseDto>}
     * @memberof FileViewResponseDtoPaginationResult
     */
    'items'?: Array<FileViewResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface ReadFileInput
 */
export interface ReadFileInput {
    /**
     * 
     * @type {number}
     * @memberof ReadFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadFileInput
     */
    'fileKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadFileInput
     */
    'combId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadFileInput
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadFileInput
     */
    'absolutePath': string;
    /**
     * 
     * @type {string}
     * @memberof ReadFileInput
     */
    'machine': string;
    /**
     * 
     * @type {string}
     * @memberof ReadFileInput
     */
    'publicKey': string;
    /**
     * 
     * @type {number}
     * @memberof ReadFileInput
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface RenameFileInput
 */
export interface RenameFileInput {
    /**
     * 
     * @type {number}
     * @memberof RenameFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RenameFileInput
     */
    'fileKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RenameFileInput
     */
    'absolutePath': string;
    /**
     * 
     * @type {string}
     * @memberof RenameFileInput
     */
    'originalPath': string;
    /**
     * 
     * @type {string}
     * @memberof RenameFileInput
     */
    'machine': string;
    /**
     * 
     * @type {number}
     * @memberof RenameFileInput
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface SearchInput
 */
export interface SearchInput {
    /**
     * 
     * @type {string}
     * @memberof SearchInput
     */
    'term'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchInput
     */
    'tags'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchInput
     */
    'primaryClassifications'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchInput
     */
    'secondaryClassifications'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof SearchInput
     */
    'startTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchInput
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchInput
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchInput
     */
    'pageIndex'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchInput
     */
    'sortField'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchInput
     */
    'sortAscending'?: boolean;
}
/**
 * 
 * @export
 * @interface SetErrorInput
 */
export interface SetErrorInput {
    /**
     * 
     * @type {number}
     * @memberof SetErrorInput
     */
    'fileViewId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SetErrorInput
     */
    'fileAuditId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SetErrorInput
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface SettingDto
 */
export interface SettingDto {
    /**
     * 
     * @type {number}
     * @memberof SettingDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SettingDto
     */
    'efsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SettingDto
     */
    'showLegalWarning'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SettingDto
     */
    'decryptionLegalWarning'?: string | null;
}
/**
 * 
 * @export
 * @interface SettingInput
 */
export interface SettingInput {
    /**
     * 
     * @type {number}
     * @memberof SettingInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SettingInput
     */
    'efsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SettingInput
     */
    'showLegalWarning'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SettingInput
     */
    'decryptionLegalWarning'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateFileInput
 */
export interface UpdateFileInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateFileInput
     */
    'primaryClassification'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFileInput
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateFileInput
     */
    'tags'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface WriteFileInput
 */
export interface WriteFileInput {
    /**
     * 
     * @type {number}
     * @memberof WriteFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WriteFileInput
     */
    'absolutePath': string;
    /**
     * 
     * @type {string}
     * @memberof WriteFileInput
     */
    'machine': string;
    /**
     * 
     * @type {number}
     * @memberof WriteFileInput
     */
    'size'?: number;
}

/**
 * SecureFilesApi - axios parameter creator
 * @export
 */
export const SecureFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsDisablePost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customkeyvaults/disable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CustomKeyVaultInput} [customKeyVaultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsEnablePost: async (customKeyVaultInput?: CustomKeyVaultInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customkeyvaults/enable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customKeyVaultInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customkeyvaults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAccessSearchPost: async (searchInput?: SearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/access/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAuditSearchPost: async (searchInput?: SearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/audit/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesBulkupdatePost: async (bulkUpdateFileInput?: BulkUpdateFileInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/bulkupdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateFileInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdGet: async (fileId: number, showDelete?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiFilesFileIdGet', 'fileId', fileId)
            const localVarPath = `/api/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (showDelete !== undefined) {
                localVarQueryParameter['showDelete'] = showDelete;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {number} [pageSize] 
         * @param {number} [pageIndex] 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdInstancesGet: async (fileId: number, pageSize?: number, pageIndex?: number, showDelete?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiFilesFileIdInstancesGet', 'fileId', fileId)
            const localVarPath = `/api/files/{fileId}/instances`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }

            if (showDelete !== undefined) {
                localVarQueryParameter['showDelete'] = showDelete;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {UpdateFileInput} [updateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdPut: async (fileId: string, updateFileInput?: UpdateFileInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiFilesFileIdPut', 'fileId', fileId)
            const localVarPath = `/api/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSearchPost: async (searchInput?: SearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSettingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SettingInput} [settingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSettingPost: async (settingInput?: SettingInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(settingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesTagsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddFileTagInput} [addFileTagInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesTagsPost: async (addFileTagInput?: AddFileTagInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addFileTagInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecureFilesApi - functional programming interface
 * @export
 */
export const SecureFilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SecureFilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCustomkeyvaultsDisablePost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCustomkeyvaultsDisablePost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CustomKeyVaultInput} [customKeyVaultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCustomkeyvaultsEnablePost(customKeyVaultInput?: CustomKeyVaultInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCustomkeyvaultsEnablePost(customKeyVaultInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCustomkeyvaultsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomKeyVaultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCustomkeyvaultsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesAccessSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesAccessSearchPost(searchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesAuditSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileAuditResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesAuditSearchPost(searchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesBulkupdatePost(bulkUpdateFileInput?: BulkUpdateFileInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesBulkupdatePost(bulkUpdateFileInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} fileId 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesFileIdGet(fileId: number, showDelete?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesFileIdGet(fileId, showDelete, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} fileId 
         * @param {number} [pageSize] 
         * @param {number} [pageIndex] 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesFileIdInstancesGet(fileId: number, pageSize?: number, pageIndex?: number, showDelete?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileInstanceResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesFileIdInstancesGet(fileId, pageSize, pageIndex, showDelete, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} fileId 
         * @param {UpdateFileInput} [updateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesFileIdPut(fileId: string, updateFileInput?: UpdateFileInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesFileIdPut(fileId, updateFileInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesSearchPost(searchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesSettingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesSettingGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SettingInput} [settingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesSettingPost(settingInput?: SettingInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesSettingPost(settingInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesTagsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FileTagResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesTagsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddFileTagInput} [addFileTagInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesTagsPost(addFileTagInput?: AddFileTagInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileTagResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesTagsPost(addFileTagInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SecureFilesApi - factory interface
 * @export
 */
export const SecureFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SecureFilesApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsDisablePost(options?: any): AxiosPromise<void> {
            return localVarFp.apiCustomkeyvaultsDisablePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomKeyVaultInput} [customKeyVaultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsEnablePost(customKeyVaultInput?: CustomKeyVaultInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiCustomkeyvaultsEnablePost(customKeyVaultInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsGet(options?: any): AxiosPromise<CustomKeyVaultDto> {
            return localVarFp.apiCustomkeyvaultsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAccessSearchPost(searchInput?: SearchInput, options?: any): AxiosPromise<FileViewResponseDtoPaginationResult> {
            return localVarFp.apiFilesAccessSearchPost(searchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAuditSearchPost(searchInput?: SearchInput, options?: any): AxiosPromise<FileAuditResponseDtoPaginationResult> {
            return localVarFp.apiFilesAuditSearchPost(searchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesBulkupdatePost(bulkUpdateFileInput?: BulkUpdateFileInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesBulkupdatePost(bulkUpdateFileInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} fileId 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdGet(fileId: number, showDelete?: boolean, options?: any): AxiosPromise<FileResponseDto> {
            return localVarFp.apiFilesFileIdGet(fileId, showDelete, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} fileId 
         * @param {number} [pageSize] 
         * @param {number} [pageIndex] 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdInstancesGet(fileId: number, pageSize?: number, pageIndex?: number, showDelete?: boolean, options?: any): AxiosPromise<FileInstanceResponseDtoPaginationResult> {
            return localVarFp.apiFilesFileIdInstancesGet(fileId, pageSize, pageIndex, showDelete, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileId 
         * @param {UpdateFileInput} [updateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdPut(fileId: string, updateFileInput?: UpdateFileInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesFileIdPut(fileId, updateFileInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSearchPost(searchInput?: SearchInput, options?: any): AxiosPromise<FileResponseDtoPaginationResult> {
            return localVarFp.apiFilesSearchPost(searchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSettingGet(options?: any): AxiosPromise<SettingDto> {
            return localVarFp.apiFilesSettingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SettingInput} [settingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSettingPost(settingInput?: SettingInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesSettingPost(settingInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesTagsGet(options?: any): AxiosPromise<Array<FileTagResponseDto>> {
            return localVarFp.apiFilesTagsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddFileTagInput} [addFileTagInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesTagsPost(addFileTagInput?: AddFileTagInput, options?: any): AxiosPromise<FileTagResponseDto> {
            return localVarFp.apiFilesTagsPost(addFileTagInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SecureFilesApi - object-oriented interface
 * @export
 * @class SecureFilesApi
 * @extends {BaseAPI}
 */
export class SecureFilesApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiCustomkeyvaultsDisablePost(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiCustomkeyvaultsDisablePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomKeyVaultInput} [customKeyVaultInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiCustomkeyvaultsEnablePost(customKeyVaultInput?: CustomKeyVaultInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiCustomkeyvaultsEnablePost(customKeyVaultInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiCustomkeyvaultsGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiCustomkeyvaultsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchInput} [searchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesAccessSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesAccessSearchPost(searchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchInput} [searchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesAuditSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesAuditSearchPost(searchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesBulkupdatePost(bulkUpdateFileInput?: BulkUpdateFileInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesBulkupdatePost(bulkUpdateFileInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} fileId 
     * @param {boolean} [showDelete] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesFileIdGet(fileId: number, showDelete?: boolean, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesFileIdGet(fileId, showDelete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} fileId 
     * @param {number} [pageSize] 
     * @param {number} [pageIndex] 
     * @param {boolean} [showDelete] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesFileIdInstancesGet(fileId: number, pageSize?: number, pageIndex?: number, showDelete?: boolean, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesFileIdInstancesGet(fileId, pageSize, pageIndex, showDelete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileId 
     * @param {UpdateFileInput} [updateFileInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesFileIdPut(fileId: string, updateFileInput?: UpdateFileInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesFileIdPut(fileId, updateFileInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchInput} [searchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesSearchPost(searchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesSettingGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesSettingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SettingInput} [settingInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesSettingPost(settingInput?: SettingInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesSettingPost(settingInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesTagsGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesTagsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddFileTagInput} [addFileTagInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesTagsPost(addFileTagInput?: AddFileTagInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesTagsPost(addFileTagInput, options).then((request) => request(this.axios, this.basePath));
    }
}


